export class SemanticLayerBuildResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runId",
            "baseName": "runId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SemanticLayerBuildResponse.attributeTypeMap;
    }
    constructor() {
    }
}
